var map = {
	"./cake.webp": 2289,
	"./correct-ico.webp": 2290,
	"./crown-blue.webp": 2291,
	"./crown.webp": 2292,
	"./pocket.webp": 2293,
	"./present.webp": 2294,
	"./relegation.webp": 2295,
	"./t-deposit.webp": 2296,
	"./t-turnover.webp": 2297,
	"./vip-1.webp": 2298,
	"./vip-2.webp": 2299,
	"./vip-3.webp": 2300,
	"./vip-4.webp": 2301,
	"./vip-5.webp": 2302,
	"./vip-badge.webp": 2303,
	"./vip-bg.webp": 2304,
	"./vip2.webp": 2305,
	"./vip3.webp": 2306,
	"./vip4.webp": 2307,
	"./vip5.webp": 2308,
	"./vip6.webp": 2309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 901;